// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import { CheckboxInput } from 'components/forms/form-elements';

// Utils
import replaceById from 'utils/replace-by-id';

export default class CheckableTR extends React.PureComponent {
  constructor() {
    super();

    this.toggleChecked = this.toggleChecked.bind(this);
  }

  toggleChecked(event) {
    const { item, list, update, handleCheck } = this.props;

    if (item.checkboxDisabled) return;
    if (handleCheck) return handleCheck(event, item);

    const clicked = { ...item, checked: !item.checked, lastChecked: !item.checked };
    const updates = [clicked];

    const lastChecked = _.find(list, 'lastChecked');
    if (lastChecked && lastChecked.id !== clicked.id) updates.push({ ...lastChecked, lastChecked: false });

    if (event.shiftKey && clicked.checked && lastChecked) {
      const start = _.indexOf(list, lastChecked);
      const end = _.indexOf(list, item);
      
      _.forEach(_.slice(list, start, end), inRange => {
        if (!inRange.checkboxDisabled) updates.push({ ...inRange, checked: true, lastChecked: false });
      });
    }

    update(replaceById(updates, list));
  }

  render() {
    const { children, item, ...passed } = this.props;

    return (
      <tr {..._.omit(passed, ['update', 'list', 'handleCheck'])} onClick={this.toggleChecked}>
        <td className="checkbox-cell">
          <CheckboxInput input={{ value: item.checked, onChange: _.noop }} disabled={!!item.checkboxDisabled} />
        </td>
        {children}
      </tr>
    );
  }
}

CheckableTR.propTypes = {
  item: PropTypes.object,
  list: PropTypes.array,
  children: PropTypes.node,
  update: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/content-containers/tables/checkable-tr.js